// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","377":"2e3a845b"}[chunkId] || chunkId) + "-" + {"108":"06e38724846d3e662912","293":"006acf63bef5b5fa6200","377":"faa65d606449a2ab83cf","452":"de15bec7ebc4fe924405"}[chunkId] + ".js";
};